import { render, staticRenderFns } from "./CeisaBarangImporPernyataan.vue?vue&type=template&id=3150685a&"
import script from "./CeisaBarangImporPernyataan.vue?vue&type=script&lang=js&"
export * from "./CeisaBarangImporPernyataan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports